import type { AxiosResponse } from 'axios';

import type { ApiHybrisErrors, HybrisApiError } from './hybrisErrorInterceptor';
import type { CustomErrorInterceptor } from './localApiAxiosErrorInterceptors';

import { appConfig } from '../../../../appConfig';
import persistance from '../../persistance/persistance';
import axiosClientFactory from './clientFactory';
import { hybrisErrorInterceptor } from './hybrisErrorInterceptor';

const APIM_HYBRIS_ROUTE_HEADER = 'x-hybris-route';

export const getUserIdUrlSegment = (userId: string): string => {
    return userId || 'anonymous';
};

const getDirectHybrisAxiosClient = <TException extends ApiHybrisErrors>(
    accessToken?: string,
    errorInterceptors?: CustomErrorInterceptor<HybrisApiError<TException>>[],
) => {
    const routeHeader = persistance.hybrisRoute.get();
    const directHybrisAxiosClient = axiosClientFactory.createDirectApiClient<
        HybrisApiError<TException>
    >(
        {
            baseURL: `${appConfig.coopSettings.serviceAccess.hybrisApiUrl}/coop`,
            headers: {
                'Ocp-Apim-Subscription-Key':
                    appConfig.coopSettings.serviceAccess.hybrisApiSubscriptionKey,
                Accept: 'application/json',
                'Ocp-Apim-Trace': 'true',
                Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
                [APIM_HYBRIS_ROUTE_HEADER]: routeHeader
                    ? encodeURIComponent(routeHeader)
                    : undefined,
            },
            params: {
                'api-version': appConfig.coopSettings.serviceAccess.hybrisApiVersion,
            },
        },
        [...(errorInterceptors || []), hybrisErrorInterceptor],
    );

    directHybrisAxiosClient.interceptors.response.use(hybrisRouteHeaderInterceptor);
    return directHybrisAxiosClient;
};

const hybrisRouteHeaderInterceptor = (response: AxiosResponse) => {
    const routeHeader = response.headers[APIM_HYBRIS_ROUTE_HEADER];
    if (routeHeader && typeof routeHeader === 'string') {
        persistance.hybrisRoute.add(routeHeader);
    }
    return response;
};

export default getDirectHybrisAxiosClient;
